import { RootState } from '../store';

export const selectAnalyticsData = (state: RootState) => {
  return state.analytics.data;
};
